// extracted by mini-css-extract-plugin
module.exports = {"block":"Hamburger_block__3LlAh","open":"Hamburger_open__LSbGp","inner":"Hamburger_inner__1I6y1"};